import React from "react";
import { Modal, Table, Spin } from "antd";
import moment from "moment";
import Bridge from "../../constants/Bridge";
import axios from "axios";

class ViewSpeechAalsFrs extends React.Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      modalLoader: false,
      modalStatus: false,
      list: [],
      selectedOption: "",
      graphdata: [],
      paginationNum: 10,
      loading: false,
      records: [],
      client_code: "3vt2n9",
      not_available_status: false,
    };
  }
  // on load component function
  componentDidMount() {}
  // on change table pagination
  handleTableChange = (pagination, filters, sorter) => {
    this.setState({ paginationNum: pagination.pageSize });
  };
  // show modal
  showDetailsModal = () => {
    let item = this.props.item;
    this.setState({ modalLoader: true }, () => this.get_client_code(item));
  };

  get_client_code = (item) => {
    let param =
      `?modality_id=` +
      item.modality_id +
      "&neurostamp_id=" +
      item.neurostamp_id +
      "&participants_id=" +
      item.participants_id +
      "&participants_accounts_id=" +
      item.participants_accounts_id;
    Bridge.participants
      .get_client_code(param)
      .then((response) => {
        if (response.status == "1") {
          if (response.data) {
            console.log("client code", response.data);
            this.setState({
              modalStatus: true,
              loading: true,
              not_available_status: false,
            });
            this.get_table_data(response.data);
          } else {
            this.setState({ modalStatus: true, not_available_status: true });
          }
        } else {
          this.setState({ modalStatus: true, not_available_status: true });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // get table data
  get_table_data = (client_code) => {
    let PROD_URL = `https://oth8dikz2d.execute-api.us-west-1.amazonaws.com/prod/report/${client_code}?stat=surveybreakdown&surveyId=ALSFRSR`;
    this.setState({ loading: true });
    axios
      .get(PROD_URL)
      .then((response) => {
        if (response.status == "200") {
          let arr = [];
          let list = response.data.results;
          for (let item of list) {
            let duplicate = [];
            item.salvation = "";
            item.speech = "";
            item.swallowing = "";
            item.handwriting = "";
            item.gastrostomy = "";
            item.cutting_food = "";
            item.dressing = "";
            item.turning = "";
            item.walking = "";
            item.climbing = "";
            item.dyspnea = "";
            item.orthopnea = "";
            item.respiratory = "";
            for (let item2 of item.categories) {
              if (!duplicate.includes(item2.label)) {
                if (item2.label == "Speech") {
                  item.speech = item2.score;
                }
                if (item2.label == "Salivation") {
                  item.salvation = item2.score;
                }
                if (item2.label == "Swallowing") {
                  item.swallowing = item2.score;
                }
                if (item2.label == "Handwriting") {
                  item.handwriting = item2.score;
                }
                if (item2.label == "Gastrostomy") {
                  item.gastrostomy = item2.score;
                }
                if (item2.label == "Cutting Food") {
                  item.cutting_food = item2.score;
                }
                if (item2.label == "Dressing and Hygiene") {
                  item.dressing = item2.score;
                }
                if (item2.label == "Turning in bed") {
                  item.turning = item2.score;
                }
                if (item2.label == "Dyspnea") {
                  item.dyspnea = item2.score;
                }
                if (item2.label == "Orthopnea") {
                  item.orthopnea = item2.score;
                }
                if (item2.label == "Respiratory insufficiency") {
                  item.respiratory = item2.score;
                }
                if (item2.label == "Walking") {
                  item.walking = item2.score;
                }
                if (item2.label == "Climbing stairs") {
                  item.climbing = item2.score;
                }
                duplicate = [...duplicate, item2.label];
              }
            }
          }
          // show latest sessions on top (descending by date)
          list.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.setState({
            records: list,
            loading: false,
            modalStatus: true,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  // get als frs for participant
  getNotesForParticipant = (item) => {
    let participant_id = item.participants_id;
    let url = `?participant_id=${participant_id}`;
    Bridge.participants
      .get_eals_frs_list(url)
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            list: response.data,
            modalLoader: false,
            modalStatus: true,
          });
        } else {
          this.setState({
            modalLoader: false,
            modalStatus: true,
            list: [],
          });
        }
      })
      .catch(function (error) {});
  };
  // sloe details modal
  hideDetailsModal = () => {
    this.setState({ modalStatus: false });
  };
  render() {
    return (
      <>
        <a onClick={() => this.showDetailsModal()}>
          <i
            className="fas fa-eye"
            style={{
              color: "#000",
              fontSize: 18,
              position: "relative",
              top: 2,
            }}
          ></i>
          <span style={{ fontSize: 14, marginLeft: 10 }}>View ALSFRS</span>
        </a>{" "}
        {/* Start als frs modal  */}
        <Modal
          title={"View ALSFRS"}
          visible={this.state.modalStatus}
          onOk={this.hideDetailsModal}
          onCancel={this.hideDetailsModal}
          width={930}
          footer={false}
        >
          <div>
            <div className="row participant-div">
              {this.state.not_available_status == false ? (
                <Spin spinning={this.state.loading}>
                  <div
                    className="Breakdown_scroolDwoml__1bbP8"
                    style={{
                      width: "100%",
                      overflowX: "scroll",
                      maxHeight: 400,
                      paddingRight: 20,
                    }}
                  >
                    <table className="table last-tab Breakdown_groupHeader__1NoFR">
                      <tr className="row-alsfrs">
                        <th></th>
                        <th
                          colSpan={3}
                          style={{ fontSize: 20, fontWeight: "600" }}
                        >
                          BULBAR
                        </th>
                        <th
                          colSpan={3}
                          style={{ fontSize: 20, fontWeight: "600" }}
                        >
                          FINE MOTOR
                        </th>
                        <th
                          colSpan={3}
                          style={{ fontSize: 20, fontWeight: "600" }}
                        >
                          GROSS MOTOR
                        </th>
                        <th
                          colSpan={3}
                          style={{ fontSize: 20, fontWeight: "600" }}
                        >
                          RESPIRATORY
                        </th>
                        <th></th>
                      </tr>
                      <tr className="row-alsfrs">
                        <th>
                          Hover mouse over categories to view answers &amp;
                          scoring
                          <img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAICAYAAACRbl3VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACOSURBVHgBxZLBCYQwEEV/koJWFrJePOyWsB14ESRH0bsleLeI1OBFhIBYhj2EiSYHQWxgHgwM//SYPwqM1KYpP7qAc/N+ZRKMEMJGIGtMl12ZAiOrW/a3zqe42lwXU7qUqE3bg5mA4yWAr4L8sVZ254jjvYcAM1X8H4lgg6f/OA4bq9BTJmWslSlQdpdJnI3yOAaqm6etAAAAAElFTkSuQmCC"
                            alt="left"
                          />
                        </th>
                        <th>Speech</th>
                        <th>Salivation</th>
                        <th>Swallowing</th>
                        <th>Handwriting</th>
                        <th>Cutting Food</th>
                        <th>Dressing and Hygiene</th>
                        <th>Turning in bed</th>
                        <th>Walking</th>
                        <th>Climbing stairs</th>
                        <th>Dyspnea</th>
                        <th>Orthopnea</th>
                        <th>Respiratory insufficiency</th>
                        <th style={{ fontSize: 20, fontWeight: "600" }}>
                          Total
                        </th>
                      </tr>
                      {this.state.records &&
                        this.state.records.map((item, index) => {
                          let total =
                            Number(item.speech) +
                            Number(item.salvation) +
                            Number(item.swallowing) +
                            Number(item.handwriting) +
                            Number(item.cutting_food) +
                            Number(item.dressing) +
                            Number(item.turning) +
                            Number(item.walking) +
                            Number(item.climbing) +
                            Number(item.dyspnea) +
                            Number(item.orthopnea) +
                            Number(item.respiratory);
                          let speech_color = "";
                          let salvation_color = "";
                          let swallowing_color = "";
                          let handwriting_color = "";
                          let cutting_food_color = "";
                          let dressing_color = "";
                          let turning_color = "";
                          let walking_color = "";
                          let climbing_color = "";
                          let dyspnea_color = "";
                          let orthopnea_color = "";
                          let respiratory_color = "";
                          if (item.speech == "1") {
                            speech_color = "als_one_color";
                          } else if (item.speech == "2") {
                            speech_color = "als_two_color";
                          } else if (item.speech == "3") {
                            speech_color = "als_three_color";
                          } else if (item.speech == "4") {
                            speech_color = "als_four_color";
                          }

                          if (item.salvation == "1") {
                            salvation_color = "als_one_color";
                          } else if (item.salvation == "2") {
                            salvation_color = "als_two_color";
                          } else if (item.salvation == "3") {
                            salvation_color = "als_three_color";
                          } else if (item.salvation == "4") {
                            salvation_color = "als_four_color";
                          }

                          if (item.swallowing == "1") {
                            swallowing_color = "als_one_color";
                          } else if (item.swallowing == "2") {
                            swallowing_color = "als_two_color";
                          } else if (item.swallowing == "3") {
                            swallowing_color = "als_three_color";
                          } else if (item.swallowing == "4") {
                            swallowing_color = "als_four_color";
                          }

                          if (item.handwriting == "1") {
                            handwriting_color = "als_one_color";
                          } else if (item.handwriting == "2") {
                            handwriting_color = "als_two_color";
                          } else if (item.handwriting == "3") {
                            handwriting_color = "als_three_color";
                          } else if (item.handwriting == "4") {
                            handwriting_color = "als_four_color";
                          }

                          if (item.cutting_food == "1") {
                            cutting_food_color = "als_one_color";
                          } else if (item.cutting_food == "2") {
                            cutting_food_color = "als_two_color";
                          } else if (item.cutting_food == "3") {
                            cutting_food_color = "als_three_color";
                          } else if (item.cutting_food == "4") {
                            cutting_food_color = "als_four_color";
                          }

                          if (item.dressing == "1") {
                            dressing_color = "als_one_color";
                          } else if (item.dressing == "2") {
                            dressing_color = "als_two_color";
                          } else if (item.dressing == "3") {
                            dressing_color = "als_three_color";
                          } else if (item.dressing == "4") {
                            dressing_color = "als_four_color";
                          }

                          if (item.turning == "1") {
                            turning_color = "als_one_color";
                          } else if (item.turning == "2") {
                            turning_color = "als_two_color";
                          } else if (item.turning == "3") {
                            turning_color = "als_three_color";
                          } else if (item.turning == "4") {
                            turning_color = "als_four_color";
                          }

                          if (item.walking == "1") {
                            walking_color = "als_one_color";
                          } else if (item.walking == "2") {
                            walking_color = "als_two_color";
                          } else if (item.walking == "3") {
                            walking_color = "als_three_color";
                          } else if (item.walking == "4") {
                            walking_color = "als_four_color";
                          }

                          if (item.climbing == "1") {
                            climbing_color = "als_one_color";
                          } else if (item.climbing == "2") {
                            climbing_color = "als_two_color";
                          } else if (item.climbing == "3") {
                            climbing_color = "als_three_color";
                          } else if (item.climbing == "4") {
                            climbing_color = "als_four_color";
                          }

                          if (item.dyspnea == "1") {
                            dyspnea_color = "als_one_color";
                          } else if (item.dyspnea == "2") {
                            dyspnea_color = "als_two_color";
                          } else if (item.dyspnea == "3") {
                            dyspnea_color = "als_three_color";
                          } else if (item.dyspnea == "4") {
                            dyspnea_color = "als_four_color";
                          }

                          if (item.orthopnea == "1") {
                            orthopnea_color = "als_one_color";
                          } else if (item.orthopnea == "2") {
                            orthopnea_color = "als_two_color";
                          } else if (item.orthopnea == "3") {
                            orthopnea_color = "als_three_color";
                          } else if (item.orthopnea == "4") {
                            orthopnea_color = "als_four_color";
                          }

                          if (item.respiratory == "1") {
                            respiratory_color = "als_one_color";
                          } else if (item.respiratory == "2") {
                            respiratory_color = "als_two_color";
                          } else if (item.respiratory == "3") {
                            respiratory_color = "als_three_color";
                          } else if (item.respiratory == "4") {
                            respiratory_color = "als_four_color";
                          }

                          return (
                            <tr className="row-alsfrs" key={index}>
                              <th>{item.date}</th>
                              <td className={speech_color}>{item.speech}</td>
                              <td className={salvation_color}>
                                {item.salvation}
                              </td>
                              <td className={swallowing_color}>
                                {item.swallowing}
                              </td>
                              <td className={handwriting_color}>
                                {item.handwriting}
                              </td>
                              <td className={cutting_food_color}>
                                {item.cutting_food}
                              </td>
                              <td className={dressing_color}>
                                {item.dressing}
                              </td>
                              <td className={turning_color}>{item.turning}</td>
                              <td className={walking_color}>{item.walking}</td>
                              <td className={climbing_color}>
                                {item.climbing}
                              </td>
                              <td className={dyspnea_color}>{item.dyspnea}</td>
                              <td className={orthopnea_color}>
                                {item.orthopnea}
                              </td>
                              <td className={respiratory_color}>
                                {item.respiratory}
                              </td>
                              <td>{total}</td>
                            </tr>
                          );
                        })}
                      {this.state.records.length == 0 && (
                        <tr>
                          <td
                            colspan={14}
                            style={{ fontSize: 20, textAlign: "center" }}
                          >
                            Not available..
                          </td>
                        </tr>
                      )}
                    </table>
                  </div>
                </Spin>
              ) : (
                <div
                  style={{
                    minHeight: 120,
                    paddingTop: 45,
                  }}
                >
                  <p className="text-center" style={{ fontSize: 22 }}>
                    Not available.
                  </p>
                </div>
              )}
            </div>
          </div>
        </Modal>
        {/* End als frs modal  */}
      </>
    );
  }
}
export default ViewSpeechAalsFrs;
